var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJawwal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.193 16.857-3.303 7.739-.709 1.776c1.277.272 2.765.424 4.082.151a8.911 8.911 0 0 0 2.804-1.291c.11-.071.21-.152.31-.233l-3.184-8.153v.01z",
    fill: "#73B158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.717 20.711z",
    fill: "#7CBC56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.216 8.441.02 6.74 3.364 1.04 3.543 1.09-6.927-8.88v.01z",
    fill: "#226188"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.236 15.182 3.364 1.04-3.364-1.04z",
    fill: "#7CBC56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.56.127a7.84 7.84 0 0 0-.938.212A8.745 8.745 0 0 0 7.48 2.922c-.15.171-.3.343-.44.525l-.04.06-.08.111 7.306 4.823L12.57.127h-.01z",
    fill: "#29A5BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.054 19.097 7.23 17.31l-6.088-3.37C.014 15.989-.086 17.846.044 19.087l.01.01z",
    fill: "#73B158"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.054 19.137v.07l.02.092c.459 2.674 1.886 4.308 2.874 5.156L7.23 17.32.054 19.107v.04-.01z",
    fill: "#68A855"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.257 24.697s.04.03.05.04l.04.03c1.447 1.07 2.835 1.756 5.29 1.887.14 0 .29.01.429.01.25 0 .499-.01.748-.03-.658-2.391-2.465-8.97-2.575-9.313l-4.281 7.134c.11.09.2.171.3.242z",
    fill: "#5B9E54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.805 26.624h.17l.09-.02c1.517-.172 2.754-.696 3.573-1.05.2-.08.369-.16.519-.211-1.667-1.01-3.005-2.25-4.043-3.461-.13-.152-.249-.293-.359-.434-.24-.293-.449-.575-.649-.858-.1-.141-.2-.272-.289-.413a8.893 8.893 0 0 1-.26-.394c-.13-.192-.239-.384-.349-.555-.07-.121-.14-.232-.2-.343-.159-.273-.299-.515-.399-.737-.379-.817-.379-.807-.379-.827",
    fill: "#5A9252"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.117 1.63A8.7 8.7 0 0 0 16.472.35a6.5 6.5 0 0 0-2.145-.343h-.04a8.356 8.356 0 0 0-1.657.1c-.03 0-.05 0-.08.011l1.657 8.314 5.02-6.72-.12-.09.01.01z",
    fill: "#1E98B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.48 6.444a8.683 8.683 0 0 0-3.244-4.722l-5.02 6.72 8.274-1.958v-.03l-.01-.01z",
    fill: "#218DA5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.236 15.182s-.02 0-.03.01h.03v-.01z",
    fill: "#7CBC56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.236 15.182s-.03 0-.03.01c-.349.1-.429.131-6.966 2.119h13.903l-3.543-1.1-3.364-1.04v.01z",
    fill: "#95C65B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.274 10.066h-.02c-1.737.888-3.134 2.16-3.952 3.622v.02c-.06.081-.11.162-.15.253l6.088 3.37-1.956-7.255-.01-.01z",
    fill: "#83BD5C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.216 8.431 6.91 3.608a8.59 8.59 0 0 0-1.656 4.753s-.05.656.02 1.695l.539-.242a16.994 16.994 0 0 1 3.662-1.1c.14-.02.28-.05.42-.07.489-.071.988-.132 1.487-.172.968-.08 1.956-.06 2.834-.04z",
    fill: "#25B3C4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.236 15.181-.02-6.74-6.976 8.88c6.537-1.998 6.607-2.019 6.966-2.12-.02 0 .03 0 .03-.01v-.01z",
    fill: "#9EC95B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.236 15.181-.02-6.74.02 6.74z",
    fill: "#7CBC56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.23 17.32 6.976-8.879c-.878-.02-1.867-.04-2.835.04a18.63 18.63 0 0 0-1.906.243 17.162 17.162 0 0 0-3.663 1.1c-.18.07-.36.161-.539.252l1.956 7.255.01-.01z",
    fill: "#91C45A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.557 19.783zM8.019 18.875c.06.11.13.222.2.343-.07-.121-.14-.232-.2-.343zM8.218 19.218c.11.182.22.363.35.555-.13-.192-.24-.383-.35-.555zM7.62 18.138c.11.212.24.464.399.737-.16-.273-.29-.525-.4-.737zM7.62 18.138a9.575 9.575 0 0 0 0 0z",
    fill: "#7CBC56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.093 17.27c-.849.343-1.707.686-2.565 1.04-1.288.524-2.575 1.06-3.863 1.594-.858.353-1.706.716-2.555 1.07-.419.181-.848.353-1.267.534l-.759.323c1.038 1.211 2.366 2.452 4.042 3.461.679.394 1.557.717 2.845 1.05l.08.02.12.03c-.02 0 0 0 0 0l.728-1.675 3.204-7.447h-.01z",
    fill: "#83BD5C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.716 19.944c1.287-.534 2.575-1.07 3.862-1.594-1.287.525-2.575 1.06-3.862 1.594z",
    fill: "#7CBC56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24 17.32s.13.324.38.828c.109.212.239.465.398.737.06.11.13.222.2.343.11.182.22.363.35.555.08.131.169.262.259.393a21.669 21.669 0 0 0 .938 1.271c.12.142.24.294.36.435.249-.101.508-.212.758-.323.419-.182.838-.353 1.267-.535.849-.353 1.697-.716 2.555-1.07 1.288-.534 2.575-1.07 3.863-1.594.858-.353 1.716-.696 2.565-1.04H7.24z",
    fill: "#91C45A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 7.967a7.72 7.72 0 0 0-.25-1.423l-.02-.07-8.274 1.957 8.444 3.108.06-.495c.04-.353.08-.908.1-1.311v-.111c.01-.575-.01-1.13-.07-1.665l.01.01z",
    fill: "#20839F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.98 17.442a9.522 9.522 0 0 0-.48-2.361l-6.357 2.24 6.577 2.784c.17-.665.34-1.614.26-2.663z",
    fill: "#5B9E54"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.72 20.106-6.577-2.785 3.244 7.689c2.305-1.635 3.034-3.835 3.044-3.865.09-.293.16-.535.22-.767l.02-.09s.01-.04.01-.051l.03-.131h.01z",
    fill: "#68A855"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.216 8.441 6.927 8.88s.848-1.474 1.527-5.772L14.216 8.44z",
    fill: "#267491"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.45 14.95c-.798-2.16-2.295-3.572-3.383-4.319a7.889 7.889 0 0 0-1.257-.706v-.172c-.01.404-.06.959-.1 1.312l-.06.494c-.679 4.299-1.517 5.752-1.527 5.772l6.357-2.24s-.03-.09-.04-.131l.01-.01z",
    fill: "#5A9252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJawwal);
export default __webpack_public_path__ + "static/media/jawwal.f29459eeddc63731a4bb5198b70701db.svg";
export { ForwardRef as ReactComponent };